import {Injectable} from '@angular/core';

import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
    constructor(private authService: AuthService) {
    }

  normalizeGroups(groups: string | string[] | null | undefined): string[] {
    if (Array.isArray(groups)) {
      return groups.filter(Boolean);
    }
    return groups ? [groups] : [];
  }

    /**
     * Platform superuser authorization (matches backend `user.is_superuser`).
     */
    isPlatformSuperuser(): boolean {
        return this.authService.isSuperUser();
    }

    /**
     * Login group label only. Use for display copy, not route/API authorization.
     */
    hasSuperuserGroup(groups: string | string[] | null | undefined): boolean {
    return this.normalizeGroups(groups).includes('Superuser');
  }

    /**
     * Platform superuser check. The groups argument is ignored; kept for call-site compatibility.
     */
    isSuperUser(_groups?: string | string[] | null | undefined): boolean {
        return this.isPlatformSuperuser();
    }

  isAdmin(groups: string | string[] | null | undefined): boolean {
    return this.normalizeGroups(groups).includes('Admin');
  }

  isSalesManager(groups: string | string[] | null | undefined): boolean {
    return this.normalizeGroups(groups).includes('Sales Manager');
  }

    isMember(groups: string | string[] | null | undefined): boolean {
        return this.normalizeGroups(groups).includes('Member');
    }

  canAccessLeadManagement(groups: string | string[] | null | undefined): boolean {
      return this.isPlatformSuperuser() || this.isSalesManager(groups);
  }

  canAccessSubscriptions(groups: string | string[] | null | undefined): boolean {
      return this.isPlatformSuperuser() || this.isAdmin(groups) || this.isSalesManager(groups);
  }

  canAccessCoreOps(groups: string | string[] | null | undefined): boolean {
      return !this.isPlatformSuperuser() && !this.isSalesManager(groups);
  }

  canAccessAlertSettings(groups: string | string[] | null | undefined): boolean {
    return this.canAccessCoreOps(groups) && (this.isAdmin(groups) || this.normalizeGroups(groups).includes('Member'));
  }

    canAccessHelpSupport(groups: string | string[] | null | undefined): boolean {
        return this.canAccessCoreOps(groups);
    }

    canAccessOrganizationsListing(groups: string | string[] | null | undefined): boolean {
        return this.isPlatformSuperuser() || this.isSalesManager(groups);
    }

    organizationsListingQueryParams(activeOnly = false): { tab: string; active?: string } {
        return activeOnly ? {tab: 'customer', active: 'true'} : {tab: 'customer'};
    }

  showMainDashboard(groups: string | string[] | null | undefined): boolean {
    return true;
  }

  getDefaultRoute(groups: string | string[] | null | undefined): string {
    return '/dashboard';
  }
}
